import { TypedLinkField } from './TypedLinkField';
import type { TopicDetails } from '@/types/topic';

export const ReferenceField = (p: { details: TopicDetails; langs: string[]; onChange: (d: TopicDetails) => void }) => (
  <TypedLinkField {...p} linkType="reference" label="Reference links" urlPlaceholder="https://…" />
);
